import * as React from "react"
import BaseController from '../base-controller';
import SectionOne from "../components/index/SectionOne";

// markup
class Index extends React.Component {
  render() {
    return (
        <BaseController>
            <SectionOne />
        </BaseController>
    )
  }
}

export default Index
